import { CheckBox, Clear, Save } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  Divider,
  Grid,
  Icon,
  IconButton,
  MenuItem,
  Radio,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup"
import React, { useEffect, useState } from "react";
import NormalTable from "../../../../Component/NormalTable";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { color } from "../../../../StyleData/Config";
import TableContainerComp from "../../../../Component/TableContainer";
import ErrorProps from "../../../../Component/Errorprops";

const Labour = ({ editData, handleCloseClick, type,workCenterId }) => {
  const [labourData, setLabourData] = useState([]);
  const [labourSelect, setLabourSelect] = useState(editData);
  const [errorTime, setErrorTime]=useState("")

  const [quantity, setQuantity] = useState(editData.quantity);
  const [planHours, setPlanHours] = useState("0");

  useEffect(() => {
    getData()
  }, []);

  const getData=async()=>{
    const labourLink = masterAPI["labourCraft"].getallbyworkcenterid;
   await axiosPrivate
      .get(`${labourLink}/${workCenterId}`)
      .then((res) => {
        console.log(res.data.result);
        const filterData = res.data.result.filter(
          (fil) => editData.craftId === fil.craftId
        );
        setLabourData(filterData);
      })
      .catch((e) => {
        setLabourData([]);
        console.log(e, "labourCraft WorkOrder");
      });
      const hours = Math.floor(editData.plannedHours);
      const minutes = Math.round((editData.plannedHours - hours) * 60);
       setPlanHours(`${hours}:${minutes < 10 ? '0' : ''}${minutes}`)
  }

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <Radio
            checked={
              labourSelect.labourId === cell.row.original.labourId &&
              labourSelect.craftId === cell.row.original.craftId
            }
            onClick={() => {
              handleCheck(cell.row.original);
            }}
          />
        );
      },
    },
    {
      Header: "Labour Name",
      accessor: "labourName",
      // disableFilters: true,
    },
    {
      Header: "Craft Name",
      accessor: "craftName",
      // disableFilters: true,
    },
  ];

  const handleCheck = (value) => {
    setLabourSelect(value);
  };

  const handleLabourSubmit = async() => {
     try {
    timeSchema.validateSync(
      { planHours },
      { abortEarly: false }
    );

    // ✅ valid
    setErrorTime("");
    console.log("Valid:", planHours);
    if (type === "wo") {
      const wotlink = masterAPI["workOrderTaskLabour"].update;
      let decimalPlanHours=Number(planHours.split(":")[0])+(Number(planHours.split(":")[1])/60)
      
      const putData = {
        id: editData.id,
        labourId: labourSelect.labourId,
        craftId: labourSelect.craftId,
        quantity: quantity,
        workOrderTaskId: editData.workOrderTaskId,
        plannedHours: decimalPlanHours,
        workedHours:decimalPlanHours,
      };
      console.log("Test",putData);

     await axiosPrivate
        .put(`${wotlink}`, putData)
        .then((res) => {
          console.log(res);
          handleCloseClick();
        })
        .catch((e) => {
          console.log(e, "createwotaskLabour");
        });
    } else {
      const jplink = masterAPI["jobPlanTaskLabour"].update;
      let decimalPlanHours=Number(planHours.split(":")[0])+(Number(planHours.split(":")[1])/60)
      const putData = {
        id: editData.id,
        labourId: labourSelect.labourId,
        craftId: labourSelect.craftId,
        quantity: quantity,
        jobPlanTaskId: editData.jobPlanTaskId,
        plannedHours: decimalPlanHours,
        workedHours:decimalPlanHours,
      };
      console.log(putData);

     await axiosPrivate
        .put(`${jplink}`, putData)
        .then((res) => {
          console.log(res);
          handleCloseClick();
        })
        .catch((e) => {
          console.log(e, "createjptaskLabour");
        });
    }

  } catch (err) {
    // ❌ get schema error
    setErrorTime(err.errors[0]);
  }
    
  };
  const timeSchema = Yup.object({
  planHours: Yup.string()
    .required("Time is required")
    .matches(
      /^\d+:[0-5]\d$/,
      "Format must be HH:MM and minutes 00-59"
    )
});

  return (
    <Grid container sx={{ p: 1 }} spacing={"1.5rem"}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: color.masterDialogTitleColor,
              fontSize: "1.1rem",
              fontWeight: 500,
            }}
          >
            Labour
          </Typography>
          <Box>
            <IconButton
              onClick={() => {
                handleLabourSubmit();
              }}
            >
              <Save sx={{ color: "#2362B4" }} />
            </IconButton>
            <IconButton
              onClick={() => {
                handleCloseClick();
              }}
            >
              <Clear sx={{ color: "#2362B4" }} />
            </IconButton>
          </Box>
        </Box>
        <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
      </Grid>
      <Grid container item xs={12} spacing={"1.5rem"}>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                // mb: color.labelmb,
                fontSize: color.labelFont,
                // color: color.labelColor,
                whiteSpace: "nowrap",
              }}
            >
              Quantity :
            </Typography>
            <TextField
              name="qauntity"
              size="small"
              placeholder="Enter Quantity"
              value={quantity}
              onChange={(e) => {
                setQuantity(e.target.value);
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                // mb: color.labelmb,
                fontSize: color.labelFont,
                // color: color.labelColor,
                whiteSpace: "nowrap",
              }}
            >
              Planned Hours(HH:MM) :
            </Typography>
            <Box>
            <TextField
              name="plannedHours"
              size="small"
              placeholder="HH:MM"
              value={planHours}
              onChange={(e) => {
                setPlanHours(e.target.value);
              }}
            />
            <ErrorProps>{errorTime}</ErrorProps>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <NormalTable data={labourData} columns={columns} filt={true} />
      </Grid>
    </Grid>
  );
};

export default Labour;
